import MLStringPopupBoxFactory from '@/Factories/ControlFactories/MLStringPopupBoxFactory';
import ComponentManager from '@/Management/ComponentManager';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ChangelogMLStringPopupBoxViewModel from '@/Components/ChangelogGrid/ChangelogMLStringPopupBoxViewModel';
import ResourceManager from '@/Management/ResourceManager';
import { IChangelogMLStringPopupBoxViewModelConstructorParameter } from "#/DefaultViewExtensionInterfaces";

export default class ChangelogMLStringPopupBoxFactory extends MLStringPopupBoxFactory {

    public viewModel: ChangelogMLStringPopupBoxViewModel;

    constructor(params: any) {
        super(params);
    }

    /**
     * @override
     * @inheritdoc 
     */
    public getControl(): JQuery<HTMLElement> {
        const control = super.getControl();
        this.manageChanges();
        return control;
    }

    /**
     * Kümmert sich um einige Sachen, die u.A. sonst von allein im DetailViewContext geschehen
     */
    private manageChanges() {
        const detailViewContext = this.context as DetailViewContext;
        // Wert darf nicht zum Server geschickt werden
        detailViewContext.genericObject.suppressNotificationFor(this.detailViewItem.name + '.ValueMLS');
        this.defineSubscription(this.viewModel.value,
            (_) => {
                // Validierung ausführen, wenn sich Wert ändert
                this.callClientValidation(true);
                // Da suppressed, muss isModified manuell gesetzt werden (force muss gesetzt sein, da ShortTransactions isModfied verschluckt)
                detailViewContext.setGenericObjectModified(true, true);
            });
    }

    /**
     * @override
     * @inheritdoc 
     */
    public createViewModel(): ChangelogMLStringPopupBoxViewModel {
        const params = this.createParamForViewModel() as IChangelogMLStringPopupBoxViewModelConstructorParameter;
        params.detailViewContext = this.context;
        return new ChangelogMLStringPopupBoxViewModel(params);
    }

    /**
     * @override
     * @inheritdoc
     * @param resetServerValidation
     */
    public callClientValidation(resetServerValidation?: boolean): void {
        super.callClientValidation(resetServerValidation);
        if (!this.isValid())
            return;

        if (this.isRequired() && this.viewModel.areValuesEmpty()) {
            this.isValid(false);
            this.invalidationText(ResourceManager.getInstance().get('REQUIRED_CONSTRAINT'));
        } else {
            this.isValid(true);
            this.invalidationText('');
        }
    }
}

ComponentManager.setFactory('ChangelogMLStringPopupBox', ChangelogMLStringPopupBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');